module.exports = __webpack_public_path__ + "img/icon_checkbox.8278d0f2.svg";